import styled from 'styled-components';
import { media } from 'utils/rwd';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 1031;
  background: rgba(0, 0, 0, 0.5);
  pointer-events: auto;
  animation: opacityFromNone 0.2s ease-out;
`;

export const ModalDialog = styled.div`
  position: ${({ $sidebar }) => ($sidebar ? 'absolute' : 'relative')};
  display: flex;
  flex-direction: column;
  margin: ${({ $sidebar }) => ($sidebar ? 0 : 'auto')};
  min-height: ${({ $sidebar }) => ($sidebar ? '100%' : '0')};
  max-height: ${({ $sidebar }) => ($sidebar ? 'none' : '90vh')};
  overflow: ${({ $sidebar }) => ($sidebar ? 'visible' : 'hidden')};
  animation: ${({ $sidebar }) =>
    $sidebar ? ' slideFromRight 0.3s ease-out;' : ' slideIn 0.3s ease-out;'};
  pointer-events: auto;
  border-radius: 0.5rem;
  ${({ $sidebar }) => $sidebar && 'right: 0'}
  width: ${({ $wide }) => ($wide ? '80vw' : 'auto')};

  ${media.sm.down`
     width: ${({ $wide }) => ($wide ? '90vw' : 'auto')};
  `}
`;

export const ModalContent = styled.div`
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  max-height: ${({ $sidebar }) => ($sidebar ? 'none' : '100%')};
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  outline: 0;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
`;

export const ModalHeader = styled.div`
  height: unset;
  flex-shrink: 0;
`;

export const ModalBody = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  padding: 1.5rem;
`;

export const ModalTitle = styled.h1`
  margin: 0;
  font-size: 20px;
  line-height: 20px;
  font-weight: 500;
`;

export const ModalSubTitle = styled.p`
  margin-top: 0.5rem;
  margin-bottom: 0;
  font-size: 14px;

  white-space: normal;
  overflow-wrap: anywhere;
`;

export const FormWrapper = styled.div`
  width: calc(600px - 3rem);
  ${media.sm.down`
     width: 100%;
  `}
`;
